import React from 'react';
import { Link } from "react-router-dom";
import './Footer.css';

export default function Footer() {
  return (
    <div className='footer p-5'>
      <div className='row'>
        <div className="col-md-2 mb-4 border-end">
          <p>&copy; All Right Reserved</p>
          <p><Link to="/privacy-policy">Privacy Policy</Link></p>
          <p><Link to="/terms-and-conditions">Terms & Conditions</Link></p>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          </div>
        </div>

        <div className="col-md-2 mb-4">
          <h5>Company</h5>
          <ul className="list-unstyled">
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/careers">Careers</a></li>
          </ul>
        </div>

        <div className="col-md-2 mb-4">
          <h5>Solutions</h5>
          <ul className="list-unstyled">
            <li>EV Charging Solutions</li>
            <li>Digital Transformation</li>
            <li>Marketing Solutions</li>
            <li>Customized Software</li>
          </ul>
        </div>

        <div className="col-md-2 mb-4">
          <h5>Support</h5>
          <ul className="list-unstyled">
            <li>Consulting Services</li>
          </ul>
        </div>

        <div className="col-md-2 mb-4">
          <h5>Contact Us</h5>
          <ul className="list-unstyled">
            <li>+94 (0) 770 065 647</li>
            <li>+94 (0) 112 677 171</li>
            <li><a href="mailto:info@ambrumsolutions.com">info@ambrumsolutions.com</a></li>
          </ul>
        </div>

        <div className="col-md-2 mb-4">
          <h5>Get in Touch</h5>
          <form>
            <input type="email" className="form-control mb-2" placeholder="Your email" />
          </form>
        </div>
      </div>
    </div>
  );
}
